import { render, staticRenderFns } from "./delete_label_modal.vue.js?vue&type=template&id=0e8bf2bc&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete_label_modal.vue?vue&type=template&id=0e8bf2bc&vue3"
import script from "./delete_label_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete_label_modal.vue?vue&type=script&lang=js&vue3"
export * from "./delete_label_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete_label_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports